export default __webpack_public_path__ + "static/media/Belt of Clarity.ac6dd3fa.jpg";